import { Dialog, DialogContent, DialogTrigger } from '@shelflix/ui-web/components/ui/dialog';
import { useEffect, useRef, useState } from 'react';

interface VideoModalProps {
  videos: string[];
  trigger: React.ReactNode;
}

export function VideoModal({ videos, trigger }: VideoModalProps) {
  const [open, setOpen] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (open) {
      setCurrentIndex(0);
    }
  }, [open]);

  const handleEnded = () => {
    if (currentIndex < videos.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setOpen(false);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="w-full max-w-3xl border-none bg-black p-4">
        <video
          ref={videoRef}
          src={videos[currentIndex]}
          controls
          autoPlay
          muted
          onEnded={handleEnded}
          className="h-auto max-h-[350px] w-full rounded"
        />
        <p className="text-muted-foreground mt-2 text-center text-sm">
          Vídeo {currentIndex + 1} de {videos.length}
        </p>
      </DialogContent>
    </Dialog>
  );
}
